import { colorsPalettes, rgba } from "@similarweb/styles";

export const modalStyles = {
    content: { padding: "20px 16px 16px 24px", width: 640, border: 0 },
    overlay: { backgroundColor: rgba(colorsPalettes.midnight["300"], 0.7) },
};

export const detailsStyles = { margin: "36px 0 12px" };
